/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EvidenceImageSignedUrlRequest
 */
export interface EvidenceImageSignedUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof EvidenceImageSignedUrlRequest
     */
    objectKey: string;
}

/**
 * Check if a given object implements the EvidenceImageSignedUrlRequest interface.
 */
export function instanceOfEvidenceImageSignedUrlRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;

    return isInstance;
}

export function EvidenceImageSignedUrlRequestFromJSON(json: any): EvidenceImageSignedUrlRequest {
    return EvidenceImageSignedUrlRequestFromJSONTyped(json, false);
}

export function EvidenceImageSignedUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceImageSignedUrlRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectKey': json['object_key'],
    };
}

export function EvidenceImageSignedUrlRequestToJSON(value?: EvidenceImageSignedUrlRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'object_key': value.objectKey,
    };
}

